import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { Page } from '../../types';
import { router } from '../../router';
import { colorTokens } from '@client/foundation/design-system/tokens';

interface MobileNavigationProps {
  pages: Page[];
}

export const MobileNavigation = ({ pages }: MobileNavigationProps) => {
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
      <IconButton
        size="large"
        aria-label="account of current user"
        aria-controls="menu-appbar"
        aria-haspopup="true"
        onClick={handleOpenNavMenu}
        color="inherit"
        sx={{
          border: '1px solid var(--ds-button-secondary-border)',
          background: 'var(--ds-button-secondary-gradient)',
          color: 'var(--ds-button-secondary-text)',
          '&:hover': {
            borderColor: 'var(--ds-button-secondary-border-hover)',
            background: 'var(--ds-button-secondary-gradient-hover)'
          }
        }}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorElNav}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        open={Boolean(anchorElNav)}
        onClose={handleCloseNavMenu}
        sx={{
          display: { xs: 'block', md: 'none' }
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            mt: 0.8,
            borderRadius: 2,
            border: (theme) =>
              `1px solid ${theme.designSystem.surface.headerDivider}`,
            backgroundColor: colorTokens.slate950Alpha95,
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)'
          }
        }}
      >
        {pages.map((page) => (
          <MenuItem
            key={page.title}
            onClick={() => {
              router.navigate(page.path);
              handleCloseNavMenu();
            }}
            sx={{
              color: 'text.primary',
              borderRadius: 1.2,
              mx: 0.6,
              my: 0.3,
              '&:hover': {
                backgroundColor: 'var(--ds-button-secondary-bg-hover)'
              }
            }}
          >
            <Typography textAlign="center">{page.title}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default MobileNavigation;
